import Component from './DynamicErrorDisplay';
import I18nService from '../../../services/I18nService';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state) => {
  // const {globalKey,flow} = state.app;

  // i18n service
  const myI18nService = I18nService.getInstance();
  const hasClose = myI18nService.exists('label.close');

  return {
    hasClose,
    closeLabel: hasClose ? myI18nService.t('label.close') : undefined,
  };
};

export default connect(mapStateToProps, undefined)(Component);
